module.exports = __webpack_public_path__ + "static/media/travel19.8ae068c0.jpg";